const VID = "cr_hero_vid";
const VAR = "cr_hero_v";
const SENT = "cr_hero_attr";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const consented = () => {
  const m = document.cookie.match(/(?:^|; )cr_consent=([^;]+)/);
  return !!m && (m[1] === "all" || m[1].includes("a1"));
};

// 50/50 headline split. The variant is stored on this device; counting only happens after analytics consent.
// Once the admin picks a winner, everyone gets it and nothing is counted.
const WINNER = "cr_hero_winner";
export const cachedWinner = () => (["A", "B"].includes(localStorage.getItem(WINNER)) ? localStorage.getItem(WINNER) : null);

export const fetchLanding = async () => {
  const r = await fetch(`${API}/public/landing`);
  if (!r.ok) throw new Error("landing");
  const d = await r.json();
  if (d.hero_winner) localStorage.setItem(WINNER, d.hero_winner);
  return d;
};

export const heroVariant = () => {
  const won = cachedWinner();
  if (won) return won;
  let v = localStorage.getItem(VAR);
  if (v !== "A" && v !== "B") { v = Math.random() < 0.5 ? "A" : "B"; localStorage.setItem(VAR, v); }
  return v;
};

const vid = () => {
  let id = localStorage.getItem(VID);
  if (!id) { id = crypto.randomUUID(); localStorage.setItem(VID, id); }
  return id;
};

export const trackHero = (event) => {
  if (!consented() || cachedWinner()) return;
  if (event === "view") { if (window.__crHeroViewSent) return; window.__crHeroViewSent = true; }
  const variant = heroVariant();
  window.posthog?.capture?.(`hero_${event}`, { hero_variant: variant });
  fetch(`${API}/exp/hero`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ vid: vid(), variant, event }), keepalive: true }).catch(() => {});
};

// After sign-up: link this device's headline variant to the new account (once).
export const attributeHero = (api) => {
  const id = localStorage.getItem(VID);
  if (!id || localStorage.getItem(SENT)) return;
  localStorage.setItem(SENT, "1");
  api.post("/exp/hero/attribute", { vid: id }).catch(() => {});
};

export const HERO_COPY = {
  A: { eyebrow: "STRIPE + BANK + QBO, CALIBRATED", h1: "Calibrate your runway. Grow with confidence." },
  B: { eyebrow: "STRIPE + BANK + QBO, CALIBRATED FOR PRE-SEED FOUNDERS", h1: "Calibrate your runway, pre-seed founder. Grow with confidence." },
};
